import { defineMessages } from 'react-intl'

export default defineMessages({
  notifyProducer: {
    id: 'containers.OrderPage.components.TaskPage.components.ActionsMenuFragments.notifyProducer',
    defaultMessage: 'Notify Producer of ready files',
  },
  notifyProducerConfirm: {
    id: 'containers.OrderPage.components.TaskPage.components.ActionsMenuFragments.notifyProducerConfirm',
    defaultMessage: 'Are you sure that the files are ready for audio post?',
  },
  notifyProducerSuccess: {
    id: 'containers.OrderPage.components.TaskPage.components.ActionsMenuFragments.notifyProducerSuccess',
    defaultMessage: 'Producer notified',
  },
  notifyProducerError: {
    id: 'containers.OrderPage.components.TaskPage.components.ActionsMenuFragments.notifyProducerError',
    defaultMessage: 'Failed to notify audio engineer!\n{errors}',
  },
})
